import { MapPin, Building2 } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { useLang } from "@/i18n";

const Card = ({ icon: Icon, label, children, testId }) => (
  <div className="p-8 rounded-2xl border border-[#D3CEC4] bg-[#F8F6F0]" data-testid={testId}>
    <div className="w-11 h-11 rounded-full bg-[#EAE5D9] grid place-items-center text-[#374F49]">
      <Icon className="w-5 h-5" />
    </div>
    <h2 className="mt-6 text-[10px] tracking-[0.28em] uppercase font-semibold text-[#374F49]">{label}</h2>
    <div className="font-serif text-2xl mt-3 leading-tight text-[#1A2522]">{children}</div>
  </div>
);

export default function Contact() {
  const { t, lang } = useLang();
  const c = t.contact;
  return (
    <>
      <Seo page="contact" />
      <PageIntro testId="contact-intro" overline={c.overline} title={c.title} />
      <section data-testid="contact-section" className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32">
        <div className="p-8 sm:p-10 rounded-2xl border border-[#D9BFB3] bg-[#F2E8E3]" data-testid="contact-notice">
          <p className="text-[10px] tracking-[0.28em] uppercase font-semibold text-[#7A4D41]">{c.noticeLabel}</p>
          <p data-testid="contact-notice-text" className={`mt-3 leading-[1.8] max-w-3xl ${lang === "pl" ? "text-[16px] sm:text-[17px] font-medium text-[#5E3328]" : "text-[14px] sm:text-[15px] text-[#7A4D41]"}`}>{t.notice.text}</p>
        </div>
        <div className="mt-6 grid sm:grid-cols-2 gap-6">
          <Card icon={Building2} label={c.clinicLabel} testId="contact-clinic">
            {c.clinicName}
            <span className="block text-base font-sans text-[#495854] mt-2">{c.clinicPlace}</span>
          </Card>
          <Card icon={MapPin} label={c.addressLabel} testId="contact-address">
            {c.addressLine1}
            <br />
            {c.addressLine2}
            <a href={`mailto:${c.email}`} data-testid="contact-email" className="block text-base font-sans text-[#495854] hover:text-[#1A2522] mt-4 break-all">{c.email}</a>
            <a href={`tel:${c.phone.replace(/\s/g, "")}`} data-testid="contact-phone" className="block text-base font-sans text-[#495854] hover:text-[#1A2522] mt-1">{c.phone}</a>
          </Card>
        </div>
      </section>
    </>
  );
}
